// extracted by mini-css-extract-plugin
module.exports = {"starIcon":"Icon_starIcon__j4hBV","active":"Icon_active__3eFWy"};